import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { PARTNER_NAV } from "@/lib/nav";
import { PropertyCard } from "@/components/PropertyCard";
import { MOCK_PROPERTIES } from "@/lib/mock-data";

export const Route = createFileRoute("/_authenticated/partner/properties/")({
  head: () => ({
    meta: [
      { title: "My properties · Landoo" },
      { name: "description", content: "Manage your Landoo property listings." },
    ],
  }),
  component: () => (
    <DashboardShell title="My properties" role="Partner" items={PARTNER_NAV}>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {MOCK_PROPERTIES.map((p) => (
          <PropertyCard key={p.id} property={p} />
        ))}
      </div>
      <div className="mt-6">
        <PlaceholderCard
          title="Bulk tools"
          description="Bulk edit, boost or archive listings coming soon."
        />
      </div>
    </DashboardShell>
  ),
});
